import { Outlet, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { BookOpen, LogOut, LayoutDashboard, HelpCircle, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-border/50 no-print">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link
            to="/dashboard"
            className="flex items-center gap-2.5 text-primary font-heading font-bold text-xl hover:opacity-80 transition-opacity"
            data-testid="logo-link"
          >
            <BookOpen className="h-6 w-6" />
            <span>EduGrade</span>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/dashboard">
              <Button
                variant={location.pathname === "/dashboard" ? "default" : "ghost"}
                size="sm"
                data-testid="nav-dashboard"
              >
                <LayoutDashboard className="h-4 w-4 mr-2" />
                Painel
              </Button>
            </Link>
            <Link to="/manual">
              <Button
                variant={location.pathname === "/manual" ? "default" : "ghost"}
                size="sm"
                data-testid="nav-manual"
              >
                <HelpCircle className="h-4 w-4 mr-2" />
                Ajuda
              </Button>
            </Link>
            {user?.is_admin && (
              <Link to="/admin">
                <Button
                  variant={location.pathname === "/admin" ? "default" : "ghost"}
                  size="sm"
                  data-testid="nav-admin"
                >
                  <ShieldCheck className="h-4 w-4 mr-2" />
                  Admin
                </Button>
              </Link>
            )}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="flex items-center gap-2" data-testid="user-menu">
                  <Avatar className="h-7 w-7">
                    <AvatarFallback className="bg-primary text-primary-foreground text-xs font-bold">
                      {user?.name?.charAt(0)?.toUpperCase() || "U"}
                    </AvatarFallback>
                  </Avatar>
                  <span className="hidden sm:inline text-sm font-medium">{user?.name}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={logout} data-testid="logout-btn">
                  <LogOut className="h-4 w-4 mr-2" />
                  Sair
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">
        <Outlet />
      </main>
      <footer className="border-t border-border/50 mt-8 no-print">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <span>EduGrade - Correção inteligente de testes</span>
          <Link to="/privacidade" className="hover:text-primary transition-colors" data-testid="privacy-link-footer">
            Política de Privacidade
          </Link>
        </div>
      </footer>
    </div>
  );
}
